export default __webpack_public_path__ + "static/media/listras.012f4ee5.png";